module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.9/_next/static/images/hero-mobile-ee8e115cd5af207d7d4eaa464da05eb7.webp";